import { render, staticRenderFns } from "./PurchaseEvents.vue?vue&type=template&id=cb084786&scoped=true"
import script from "./PurchaseEvents.vue?vue&type=script&lang=js"
export * from "./PurchaseEvents.vue?vue&type=script&lang=js"
import style0 from "./PurchaseEvents.vue?vue&type=style&index=0&id=cb084786&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb084786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb084786')) {
      api.createRecord('cb084786', component.options)
    } else {
      api.reload('cb084786', component.options)
    }
    module.hot.accept("./PurchaseEvents.vue?vue&type=template&id=cb084786&scoped=true", function () {
      api.rerender('cb084786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/PurchaseEvents.vue"
export default component.exports